import type { IconSvgObject } from './types';

const Grid2X2Icon: IconSvgObject = [
  ["path", { d: "M4.31411 19.682C5.63213 21 7.75345 21 11.9961 21C16.2387 21 18.3601 21 19.6781 19.682C20.9961 18.364 20.9961 16.2426 20.9961 12C20.9961 7.75736 20.9961 5.63604 19.6781 4.31802C18.3601 3 16.2387 3 11.9961 3C7.75345 3 5.63213 3 4.31411 4.31802C2.99609 5.63604 2.99609 7.75736 2.99609 12C2.99609 16.2426 2.99609 18.364 4.31411 19.682Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.9961 3V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21.002 11.9922H3.00195", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Grid2X2Icon;
